import CarouselLayout from 'components/Content/ProductListLayout/CarouselLayout/CarouselLayout';

export default CarouselLayout;
